import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import Vant from 'vant';
import 'vant/lib/index.css'; // 引入全部样式

const app = createApp(App)
app.use(Vant);
app.use(router)
app.mount('#app');

